import React, { useState } from 'react'
import Select from 'react-select'
import { GetCookieToken } from '../../pages/Cookie/GetCookie';
import axios from 'axios';
import { Input } from 'reactstrap';
const API_URL = process.env.REACT_APP_API_CORS;
const token = GetCookieToken("userToken");

const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    height: "38px",
    borderRadius: "0 .375rem .375rem 0",
    borderColor: "#ced4da",
    boxShadow: "none",
  }),
  valueContainer: (base) => ({
    ...base,
    height: "38px",
    padding: "0 8px",
  }),
  input: (base) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: "38px",
  }),
};

const UserSelector = ({ onChange, placeholder, value, className, style, type, disabled, error }) => {
    const [loading, setIsLoading] = useState(false)
    const [user, setUser] = useState([])

    const handleSelect = (e) => {
      if (onChange) {
        onChange(e);
      }
    };

    const fetchUser = async (search) => {
      setIsLoading(true)
      try {
        const url = `${API_URL}/api/users/datatable`;
        const params = new URLSearchParams({
            page: 1,
            size: 100,
            "order[0]": "user_name",
            "order[1]": "ASC",
            "filter[user_name_status][0]": "ปกติ",
            "filter[user_outsider][0]": 0,
            "filter[user_special][0]": 0,
            search: search,
        });
        const config = { headers: { Authorization: `Bearer ${token}` }, params };
        const response = await axios.get(url, config);
        const data = response.data.result
        let options = [];
        (data.length) > 0 && (await data.map(async x => {
            options.push({ value: { user_id: x?.user_id, user_name: x?.user_name, cont_to: x?.cont_to, user_position_name: x?.user_position_name }, label: x?.user_name })
        }))
        setUser(options);
        
      } catch (error) {
        console.error("Error fetching approve user flow:", error);
      } finally {
        setIsLoading(false)
      }
    }

    return (
        <React.Fragment>
          <Select
                className={`basic-single ${className}`}
                styles={type === "normal" ? selectStyles : style}
                isDisabled={disabled}
                defaultValue='0'
                isSearchable={true}
                value={value}
                name="color"
                placeholder={placeholder}
                onInputChange={(e) => {(e.length > 0) && fetchUser(e)}}
                onChange={(e) => { handleSelect(e?.value) }}
                options={user}
            />
            {/* } */}
        </React.Fragment>
    )
}

export default UserSelector